module.exports = __webpack_public_path__ + "static/media/csat_example.31d12b17.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/csat_example.png
// module id = 8681
// module chunks = 0